export default __webpack_public_path__ + "static/rightHand-1e1cb0c7e20a2bef3d89306549adb156.png";